<template>
  <div class="header">
    <div class="left fl">
      <div class="logo">千川工作台</div>
    </div>

    <div class="right fr">
      <el-button v-if="showRecharge" type="primary" size="small" class="mr-10" @click="showRechargeVisible">
        充值积分
      </el-button>

      <div class="message-entry" @click="goMessageCenter">
        <el-badge :value="messageSummary.unreadCount || 0" :hidden="!(messageSummary.unreadCount > 0)" :max="99">
          <i class="el-icon-bell header-icon"></i>
        </el-badge>
      </div>

      <el-dropdown @command="avatarCommand">
        <div class="right-dropdown">
          <div class="avatar fl">
            <el-image v-if="user.avatar" :src="user.avatar" fit="cover"></el-image>
            <el-avatar v-else icon="el-icon-user"></el-avatar>
          </div>
          <div class="username dib">
            <span>{{ user.username }}</span>
            <i class="el-icon-caret-bottom"></i>
          </div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="myInfo" icon="el-icon-info">我的信息</el-dropdown-item>
          <el-dropdown-item command="password" icon="el-icon-s-cooperation">修改密码</el-dropdown-item>
          <el-dropdown-item command="logout" icon="el-icon-s-release">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog
      title="积分充值"
      :visible.sync="rechargeVisible"
      custom-class="common-dialog"
      :close-on-click-modal="false"
      @close="rechargeVisibleClose"
      width="30%"
    >
      <div class="dialog_body">
        <el-form label-position="right" label-width="90px" :model="rechargeForm" ref="rechargeForm">
          <div class="qrcode" v-qr="rechargeForm.address" v-if="rechargeForm.address" />
          <div class="qrcode-tip">1 USDT = {{ rechargeForm.scale }} 积分</div>
          <el-form-item
            label="USDT地址"
            prop="address"
            :rules="[{ message: '地址不能为空', trigger: 'blur', required: true }]"
          >
            <el-input placeholder="请输入USDT地址" v-model="rechargeForm.address" class="trx-address" />
            <el-button class="fr copyAddress" type="primary" size="medium" @click="copyAddress">复制</el-button>
          </el-form-item>
          <div class="tip">最低充值 1 USDT。如已转账，请等待 1-5 分钟后刷新。</div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="getRechargeOrder">刷新</el-button>
        <el-button type="primary" size="small" @click="getRechargeOrder">我已充值</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import constants from "../../constants/constants";
import PubSub from "pubsub-js";

const violationScope = require("../../utils/qianchuanViolationScope");
const MESSAGE_CENTER_PATH = "/qdd/admin/ViolationMessageCenter.html";

export default {
  name: "Header",
  props: ["menuCollapse"],
  data() {
    return {
      user: {},
      version: constants.version,
      score: 0,
      rechargeVisible: false,
      rechargeForm: {
        address: "",
        scale: "",
      },
      showRecharge: false,
      timer: null,
      scoreTimer: null,
      messageTimer: null,
      messageTopic: null,
      messageSummary: {
        unreadCount: 0,
        highRisk: false,
        latestMessage: null,
      },
      messageReady: false,
    };
  },
  mounted() {
    this.hydrateUserFromStorage();
    this.getInfo();
    if (this.messageReady) {
      this.fetchMessageSummary();
      this.startMessageTimer();
    }
    this.messageTopic = PubSub.subscribe("refreshViolationMessageSummary", (topic, payload) => {
      if (payload) {
        this.applyMessageSummary(payload);
        return;
      }
      this.fetchMessageSummary();
    });
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.scoreTimer) {
      clearInterval(this.scoreTimer);
    }
    if (this.messageTimer) {
      clearInterval(this.messageTimer);
    }
    if (this.messageTopic) {
      PubSub.unsubscribe(this.messageTopic);
    }
  },
  methods: {
    hydrateUserFromStorage() {
      const adminInfo = this.readAdminInfoFromStorage();
      if (Object.keys(adminInfo).length) {
        this.user = adminInfo;
        this.messageReady = true;
      }
    },
    readAdminInfoFromStorage() {
      try {
        return JSON.parse(window.localStorage.getItem("adminInfo") || "{}");
      } catch (error) {
        return {};
      }
    },
    isMessageCenterRoute() {
      return this.$route && this.$route.path === MESSAGE_CENTER_PATH;
    },
    applyMessageSummary(summary) {
      this.messageSummary = Object.assign({}, this.messageSummary, {
        unreadCount: summary && summary.unreadCount ? summary.unreadCount : 0,
        highRisk: !!(summary && summary.highRisk),
        latestMessage: summary ? summary.latestMessage || null : null,
      });
    },
    resetMessageSummary() {
      this.applyMessageSummary({
        unreadCount: 0,
        highRisk: false,
        latestMessage: null,
      });
    },
    resolveMessageScope() {
      return violationScope.resolveViolationScope(this.user, {}, {
        allowStoredAgentId: true,
      });
    },
    getInfo() {
      this.$axios.post({
        url: "/adminInfo/my",
        success: (res) => {
          this.user = res.data || {};
          window.localStorage.setItem("adminInfo", JSON.stringify(this.user));
          this.messageReady = true;
          this.fetchMessageSummary();
          this.startMessageTimer();
        },
        error: () => {
          this.$message.error("加载用户信息失败");
        },
      });
    },
    fetchMessageSummary() {
      if (!this.messageReady || this.isMessageCenterRoute()) {
        return;
      }
      const scopeState = this.resolveMessageScope();
      if (!scopeState.ready) {
        this.resetMessageSummary();
        return;
      }
      this.$axios.post({
        url: "/qianchuanViolationMessage/summary",
        data: scopeState.requestData,
        loading: false,
        success: (res) => {
          if (res.code === 0 && res.data) {
            this.applyMessageSummary(res.data);
          }
        },
      });
    },
    startMessageTimer() {
      if (this.messageTimer) {
        return;
      }
      this.messageTimer = setInterval(() => {
        this.fetchMessageSummary();
      }, 60 * 1000);
    },
    goMessageCenter() {
      if (this.$route.path !== MESSAGE_CENTER_PATH) {
        this.$router.push(MESSAGE_CENTER_PATH);
      }
    },
    avatarCommand(command) {
      const { path } = this.$route;
      switch (command) {
        case "myInfo":
          if (path !== this.feUrl + "/myinfo.html") {
            this.$router.push(this.feUrl + "/myinfo.html");
          }
          break;
        case "password":
          if (path !== this.feUrl + "/password.html") {
            this.$router.push(this.feUrl + "/password.html");
          }
          break;
        case "logout":
          this.$confirm("确认退出当前工作台吗？", "提示", {
            confirmButtonText: "退出",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$axios.post({
                url: "/system/logout",
                success: (res) => {
                  if (res.code === 0) {
                    this.$message.success("已退出登录");
                    window.localStorage.removeItem("username");
                    window.localStorage.removeItem("sessionId");
                    location.href = this.feUrl + "/login.html";
                  }
                },
                error: () => {
                  this.$message.error("退出登录失败");
                },
              });
            })
            .catch(() => false);
          break;
      }
    },
    timeTask() {
      this.timer = setInterval(() => {
        // reserved for score refresh
      }, 5 * 1000);
    },
    scoreTimerTask() {
      this.scoreTimer = setInterval(() => {
        this.scoreLack();
      }, 10 * 60 * 1000);
    },
    scoreLack() {
      if (this.score <= 0) {
        this.$notify({
          type: "warning",
          title: "积分不足",
          message: "当前积分不足，请及时充值。",
          position: "bottom-right",
        });
      }
    },
    getScore() {
      this.$axios.post({
        url: "/proxyWallet/score",
        loading: false,
        success: (res) => {
          if (res.code === 136) {
            this.showRecharge = false;
            return;
          }
          if (res.code === 0) {
            this.score = res.data;
            if (!this.timer) {
              this.timeTask();
            }
            if (!this.scoreTimer) {
              this.scoreTimerTask();
              this.scoreLack();
            }
          } else {
            this.$message.error(res.msg || "加载积分失败");
          }
          this.showRecharge = true;
        },
      });
    },
    showRechargeVisible() {
      this.$axios.post({
        url: "/proxyWallet/address",
        loading: false,
        success: (res) => {
          if (res.code === 0) {
            const ele = document.getElementById("header");
            ele.style["z-index"] = 3000;
            this.rechargeForm.address = res.data.address;
            this.rechargeForm.scale = res.data.scale;
            this.rechargeVisible = true;
          } else if (res.code !== 136) {
            this.$message.error(res.msg || "加载充值地址失败");
          }
        },
      });
    },
    rechargeVisibleClose() {
      const ele = document.getElementById("header");
      if (ele) {
        ele.style["z-index"] = 99;
      }
    },
    copyAddress() {
      this.copyToClipboard(this.rechargeForm.address);
      this.$notify.success({
        title: "复制成功",
        message: "地址已复制到剪贴板",
        position: "bottom-right",
      });
    },
    copyToClipboard(content) {
      if (window.clipboardData) {
        window.clipboardData.setData("text", content);
      } else {
        (function (value) {
          document.oncopy = function (e) {
            e.clipboardData.setData("text", value);
            e.preventDefault();
            document.oncopy = null;
          };
        })(content);
        document.execCommand("Copy");
      }
    },
    getRechargeOrder() {
      this.rechargeVisible = false;
      this.$axios.post({
        url: "/agentRecharge/getOrder",
        loading: false,
      });
    },
  },
};
</script>

<style scoped>
.header {
  height: 100%;
  line-height: 60px;
}

.header * {
  color: #ffffff !important;
}

.logo {
  font-size: 1.4rem;
  font-family: NSimSun;
  font-weight: 700;
}

.right {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 100%;
}

.message-entry {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.message-entry:hover {
  background: rgba(255, 255, 255, 0.12);
}

.header-icon {
  font-size: 20px;
}

.avatar {
  cursor: pointer;
  height: 40px;
  padding: 10px 5px;
}

.avatar .el-image {
  height: 40px;
  width: 40px;
  border-radius: 40px;
}

.username {
  cursor: pointer;
  padding-right: 5px;
}

.right-dropdown {
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 0 6px;
}

.right-dropdown:hover {
  background-color: #001528;
}

.dialog >>> .el-button--default {
  color: #606266 !important;
}

.trx-address {
  width: calc(100% - 100px);
}

.copyAddress {
  margin-top: 3px;
}

.qrcode {
  text-align: center;
}

.qrcode-tip,
.tip {
  color: #606266 !important;
}
</style>
